import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  OnInit,
  inject,
  viewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { javascript } from '@codemirror/lang-javascript';
import { EditorState } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { basicSetup } from 'codemirror';
import { switchMap } from 'rxjs';

import {
  CustomResult,
  CustomResultOfGetCurrentUserCustomerDomainConfigurationDto,
  GetCurrentUserCustomerDomainConfigurationDto,
  GetEnumValuesDto,
  UpdateCustomerDomainConfigurationCommand,
} from 'src/app/core/api/models';
import {
  CustomerDomainConfigurationsService,
  CustomerDomainsService,
  EnumsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import { CustomerDomainFormComponent } from 'src/app/pages/infrastructure/customer-domains/domain-form/domain-form.component';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { ImageUploaderComponent } from 'src/app/shared/components/image-uploader/image-uploader.component';
import { TabsDynamicComponent } from '../../../tabs-dynamic/tabs-dynamic.component';

@Component({
  selector: 'app-domain-configurations-form',
  templateUrl: './domain-configurations-form.component.html',
  styleUrl: './domain-configurations-form.component.scss',
  imports: [BaseFormModule, SharePipesModule, ImageUploaderComponent],
})
export class DomainConfigurationsFormComponent
  extends CustomerDomainFormComponent
  implements OnInit
{
  //#region properties
  enumService = inject(EnumsService);

  baseObserver = {
    next: (result: CustomResult) => {
      this.apiNotificationService.notifyMessage({ result });
      if (result.isSucceed) {
        this.tabsDynamicComponent.manualCloseTab('domainConfiguration');
        this.dynamicTabService.setActiveTab('dashboard');
      }
    },
    error: (error) => {
      ConsoleService.error('error', error);
    },
    complete: () => (this.loading = false),
  };

  pageName = 'customerDomains';
  LoginPageModesEnumValues: GetEnumValuesDto[] = [];
  baseModel: GetCurrentUserCustomerDomainConfigurationDto = {};
  isShowGroupPrice: boolean = true;

  appStateService = inject(AppStateService);
  readonly editor = viewChild.required<ElementRef>('editor');
  //#endregion

  constructor(
    protected customerDomainConfigurationsService: CustomerDomainConfigurationsService,
    protected tabsDynamicComponent: TabsDynamicComponent,
    private dynamicTabService: DynamicTabService,
    protected currentService: CustomerDomainsService,

    protected http: HttpClient
  ) {
    super(http);
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.getCustomerDomainConfigurationsApi();
      this.initForm();
      this.formPageConfig.isEditMode = true;
      this.pageVocabs = 'pages.customerDomains.form.';
      this.fields = 'pages.customerDomains.form.fields.';
      this.title = 'pages.customerDomains.form.editTitle';

      if (!this.model.sliderPicturePaths?.length)
        this.model.sliderPicturePaths = [''];
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  // تابع برای حذف کامنت‌ها
  removeComments(text: string): string {
    // استفاده از الگوی منظم برای حذف خطوط کامنت
    return text.replace(/^\s*\/\/.*$/gm, '').trim();
  }

  initModel(): void {
    super.initModel();
    this.model = Object.assign({}, this.baseModel);
    if (TransferDataService.enumValues)
      this.LoginPageModesEnumValues = Object.assign(
        [],
        TransferDataService.enumValues
      );
  }

  initForm() {
    this.domainInfoForm = new FormGroup({
      defaultGroupPriceId: new FormControl('', Validators.required),
      defaultGroupPriceCategoryId: new FormControl('', [Validators.required]),
    });

    this.chooseTemplateForm = new FormGroup({
      desktop: new FormControl('', Validators.required),
    });

    this.form = new FormGroup({
      dashboardMode: new FormControl(''),
      primaryColor: new FormControl(''),
      secondaryColor: new FormControl(''),
    });
  }

  //#region Api
  getCustomerDomainConfigurationsApi(): void {
    this.unSubs();

    this.pageConfig.loading = true;
    this.loading = true;
    this.customerDomainConfigurationsService
      .customerDomainConfigurationsGetCurrentUserCustomerDomainConfiguration()
      .pipe(this.basePipeOperators())
      .subscribe(
        (res: CustomResultOfGetCurrentUserCustomerDomainConfigurationDto) => {
          try {
            if (res.isSucceed) {
              this.model = res?.data;
              this.baseModel = Object.assign({}, res?.data);
              this.createEditorView();
            }
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.systemManagement
            );
          }
        }
      );
  }
  //Update
  baseUpdateApi(model: UpdateCustomerDomainConfigurationCommand) {
    this.unSubs();
    this.model.sliderPicturePaths = this.model?.sliderPicturePaths.filter(
      (item) => item.trim() !== ''
    );

    this.loading = true;
    this.customerDomainConfigurationsService
      .customerDomainConfigurationsUpdateCustomerDomainConfiguration({
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
  onSubmit() {
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;

    try {
      // When a logo is not uploaded, pishgam logo will be uploaded and displayed by default
      if (!this.model?.logoSrc) {
        this.http
          .get('../../../../../assets/media/logos/logo.png', {
            responseType: 'blob',
          })
          .pipe(switchMap((blob) => this.convertBlobToBase64(blob)))
          .subscribe((base64ImageUrl) => {
            this.model.logoSrc = base64ImageUrl as string;
            this.checkCreateOrUpdate();
          });
      } else this.checkCreateOrUpdate();
    } catch (error) {
      ConsoleService.error('error', error);
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  createEditorView(): void {
    new EditorView({
      state: EditorState.create({
        doc: this.model.header
          ? this.model.header
          : '// برای نمونه تگ زیر را وارد کنید \n //<link href="your address">',
        extensions: [
          basicSetup,
          javascript(),
          EditorView.updateListener.of((update) => {
            if (update.docChanged) {
              this.model.header = this.removeComments(
                update.state.doc.toString()
              );
            }
          }),
        ],
      }),
      parent: this.editor().nativeElement,
    });
  }

  onReset() {
    this.resetFormCounter++;
    this.model = {};
    this.initModel();
  }
}
